// extracted by mini-css-extract-plugin
export var deleteIcon = "_o8-5";
export var deleteOption = "_o8-3";
export var divider = "_o8-2";
export var downloadIcon = "_o8-4";
export var drawer = "_o8-0";
export var drawerFooter = "_o8-6";
export var drawerOpen = "_o8-1";
export var highlighted = "_o8-7";
export var lighterHighlight = "_o8-8";